import { render, staticRenderFns } from "./company-documents-action-menu.vue?vue&type=template&id=65c77818&"
import script from "./company-documents-action-menu.vue?vue&type=script&lang=js&"
export * from "./company-documents-action-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports